module.exports = __webpack_public_path__ + "static/media/NR.86641c7f.svg";